import { ConfigStore } from '@estee/elc-service';

export interface IPaymentDetails {
    provider: string;
    publicKey: string;
    accountId: string;
    sandboxMode: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class DrupalConfigStore extends ConfigStore<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(values: any) {
        super(values);
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapConfigToProps = (drupalProps: any) => {
    const castDrupalPropToNumber = (key: string) => {
        const drupalProp = drupalProps[key];

        return typeof drupalProp === 'string' ? Number(drupalProp) : drupalProp;
    };

    const sessionExpiredStartTime = castDrupalPropToNumber('sessionExpiredStartTime');
    const sessionExpiredTimeout = castDrupalPropToNumber('sessionExpiredTimeout');
    const costLimit = castDrupalPropToNumber('costLimit');
    const maxQuantity = castDrupalPropToNumber('maxQuantity');
    const threeInstallmentsLimit = castDrupalPropToNumber('threeInstallmentsLimit');
    const sixInstallmentsLimit = castDrupalPropToNumber('sixInstallmentsLimit');
    const baseUrl = drupalProps.defaultDomain;

    return {
        ...drupalProps,
        sessionExpiredStartTime,
        sessionExpiredTimeout,
        costLimit,
        maxQuantity,
        threeInstallmentsLimit,
        sixInstallmentsLimit,
        baseUrl
    };
};
